export default __webpack_public_path__ + "static/media/feature_4.37c14aef.jpg";